import { Login } from "@mui/icons-material";
import { Outlet } from "react-router-dom";
import Layout from "../pages/Layout";
import { useEffect, useState } from "react";

const AuthRoute = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const checkUserToken = () => {
        const userToken = localStorage.getItem('isAuthenticated');
        console.log('userToken',userToken);
        if (!userToken || userToken === 'undefined' || userToken==null) {
            setIsLoggedIn(false);
            //    return navigate('/login');
        } else {
            setIsLoggedIn(true);
        }
    }

    useEffect(() => {
        checkUserToken();
    }, [isLoggedIn]);

    return (<Outlet/>)
}

export default AuthRoute;